import { FC } from 'react';
import classNames from 'classnames';
import { ErrorMessage, Field, FieldProps } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import { FeedbackMessage } from 'src/UI';
import { InputNumber } from 'src/Components/Controls';

interface INumberBoxProps {
	name: string;
	title: string;
	setData: Function;
	isRequired: boolean;
	disabled: boolean;
	defaultValue?: any;
	placeholder?: string;
	readOnly?: boolean;
}

/**
 * Текстовое поле
 */
const NumberBox: FC<INumberBoxProps> = (props) => {
	const {
		name,
		title,
		setData,
		readOnly = false,
		isRequired = false,
		disabled = false,
		placeholder,
	} = props;

	const onChangeValueHandler = (value: number | null, form: any): any => {
		form.setFieldValue(name, value);
		!!setData &&
			setData((data: any) => {
				return { ...data, [name]: value };
			});
	};

	return (
		<Field id={name} name={name}>
			{({ form, meta, field }: FieldProps) => {
				return (
					<FormGroup>
						{!!title && (
							<Label htmlFor={name}>
								<b
									className={
										isRequired ? 'field_asterix' : ''
									}
								>
									{title}
								</b>
							</Label>
						)}
						<InputNumber
							// id={ "input_" + name }
							{...field}
							size="large"
							readOnly={readOnly || disabled}
							placeholder={placeholder}
							value={field.value ?? ''}
							className={classNames({
								'is-invalid': meta.error && meta.touched,
							})}
							onChangeValue={(e) => {
								return onChangeValueHandler(
									e as number | null,
									form,
								);
							}}
						/>
						{meta.error && meta.touched && (
							<FeedbackMessage message={meta.error} />
						)}
					</FormGroup>
				);
			}}
		</Field>
	);
};

export default NumberBox;
